import { CfcRule, HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '../../models';
import { LocDisplayType } from '../../models/display-type';
import { SYSTEM_ENUM_ROOT, SYSTEM_ENUM_TYPE } from '../shared-data';

const dpRoot = `${SYSTEM_ENUM_ROOT}|Cfc Rule|`;

const sharedLocData: Pick<LocDef, 'displayType' | 'htmlAllowed' | 'portal' | 'shared'> = {
	displayType: `${SYSTEM_ENUM_TYPE}` as LocDisplayType,
	htmlAllowed: false,
	shared: true,
	portal: 'SP',
};

type LocNameStart = 'SPCfcRuleEnum';
export type SPCfcRuleLocs =
	| `${LocNameStart}CcatAchieved`
	| `${LocNameStart}CcatActive`
	| `${LocNameStart}CcatExpired`
	| `${LocNameStart}CcatInactive`
	| `${LocNameStart}CcatSuspended`
	| `${LocNameStart}CrcatAchieved`
	| `${LocNameStart}CrcatActive`
	| `${LocNameStart}CrcatInactive`
	| `${LocNameStart}ExcatFailed`
	| `${LocNameStart}ExcatPassed`
	| `${LocNameStart}ExcatTaken`
	| `${LocNameStart}IcCodeAddr1`
	| `${LocNameStart}StandingAchieved`
	| `${LocNameStart}StandingActive`
	| `${LocNameStart}StandingInactive`
	| `${LocNameStart}ClaListItems`;

export const spCfcRuleEnumLocs: LocDefs<SPCfcRuleLocs> = {
	SPCfcRuleEnumCcatAchieved: {
		defaultValue: 'Credentials Achieved',
		displayPath: `${dpRoot}${CfcRule.CcatAchieved}`,
		description: `System value for '${CfcRule.CcatAchieved}' Cfc Rule.`,
		legacyName: 'Announcements/System.Enum.CfcRule.CcatAchieved',
		feature: HubFeature.Credential,
		...sharedLocData,
	},
	SPCfcRuleEnumCcatActive: {
		defaultValue: 'Credentials Active',
		displayPath: `${dpRoot}${CfcRule.CcatActive}`,
		description: `System value for '${CfcRule.CcatActive}' Cfc Rule.`,
		legacyName: 'Announcements/System.Enum.CfcRule.CcatActive',
		feature: HubFeature.Credential,
		...sharedLocData,
	},
	SPCfcRuleEnumCcatExpired: {
		defaultValue: 'Credentials Expired',
		displayPath: `${dpRoot}${CfcRule.CcatExpired}`,
		description: `System value for '${CfcRule.CcatExpired}' Cfc Rule.`,
		legacyName: 'Announcements/System.Enum.CfcRule.CcatExpired',
		feature: HubFeature.Credential,
		...sharedLocData,
	},
	SPCfcRuleEnumCcatInactive: {
		defaultValue: 'Credentials Inactive',
		displayPath: `${dpRoot}${CfcRule.CcatInactive}`,
		description: `System value for '${CfcRule.CcatInactive}' Cfc Rule.`,
		legacyName: 'Announcements/System.Enum.CfcRule.CcatInactive',
		feature: HubFeature.Credential,
		...sharedLocData,
	},
	SPCfcRuleEnumCcatSuspended: {
		defaultValue: 'Credentials Suspended',
		displayPath: `${dpRoot}${CfcRule.CcatSuspended}`,
		description: `System value for '${CfcRule.CcatSuspended}' Cfc Rule.`,
		legacyName: 'Announcements/System.Enum.CfcRule.CcatSuspended',
		feature: HubFeature.Credential,
		...sharedLocData,
	},
	SPCfcRuleEnumCrcatAchieved: {
		defaultValue: 'Other Requirements Achieved',
		displayPath: `${dpRoot}${CfcRule.CrcatAchieved}`,
		description: `System value for '${CfcRule.CrcatAchieved}' Cfc Rule.`,
		legacyName: 'Announcements/System.Enum.CfcRule.CrcatAchieved',
		feature: HubFeature.OtherRequirement,
		...sharedLocData,
	},
	SPCfcRuleEnumCrcatActive: {
		defaultValue: 'Other Requirements Active',
		displayPath: `${dpRoot}${CfcRule.CrcatActive}`,
		description: `System value for '${CfcRule.CrcatActive}' Cfc Rule.`,
		legacyName: 'Announcements/System.Enum.CfcRule.CrcatActive',
		feature: HubFeature.OtherRequirement,
		...sharedLocData,
	},
	SPCfcRuleEnumCrcatInactive: {
		defaultValue: 'Other Requirements Inactive',
		displayPath: `${dpRoot}${CfcRule.CrcatInactive}`,
		description: `System value for '${CfcRule.CrcatInactive}' Cfc Rule.`,
		legacyName: 'Announcements/System.Enum.CfcRule.CrcatInactive',
		feature: HubFeature.OtherRequirement,
		...sharedLocData,
	},
	SPCfcRuleEnumExcatFailed: {
		defaultValue: 'Exams Failed',
		displayPath: `${dpRoot}${CfcRule.ExcatFailed}`,
		description: `System value for '${CfcRule.ExcatFailed}' Cfc Rule.`,
		legacyName: 'Announcements/System.Enum.CfcRule.ExcatFailed',
		feature: HubFeature.Exam,
		...sharedLocData,
	},
	SPCfcRuleEnumExcatPassed: {
		defaultValue: 'Exams Passed',
		displayPath: `${dpRoot}${CfcRule.ExcatPassed}`,
		description: `System value for '${CfcRule.ExcatPassed}' Cfc Rule.`,
		legacyName: 'Announcements/System.Enum.CfcRule.ExcatPassed',
		feature: HubFeature.Exam,
		...sharedLocData,
	},
	SPCfcRuleEnumExcatTaken: {
		defaultValue: 'Exams Taken',
		displayPath: `${dpRoot}${CfcRule.ExcatTaken}`,
		description: `System value for '${CfcRule.ExcatTaken}' Cfc Rule.`,
		legacyName: 'Announcements/System.Enum.CfcRule.ExcatTaken',
		feature: HubFeature.Exam,
		...sharedLocData,
	},
	SPCfcRuleEnumIcCodeAddr1: {
		defaultValue: 'Countries',
		displayPath: `${dpRoot}${CfcRule.IcCodeAddr1}`,
		description: `System value for '${CfcRule.IcCodeAddr1}' Cfc Rule.`,
		legacyName: 'Announcements/System.Enum.CfcRule.IcCodeAddr1',
		feature: HubFeature.Core,
		...sharedLocData,
	},
	SPCfcRuleEnumStandingAchieved: {
		defaultValue: 'Standings Achieved',
		displayPath: `${dpRoot}${CfcRule.StandingAchieved}`,
		description: `System value for '${CfcRule.StandingAchieved}' Cfc Rule.`,
		legacyName: 'Announcements/System.Enum.CfcRule.StandingAchieved',
		feature: HubFeature.CredentialAchievements,
		...sharedLocData,
	},
	SPCfcRuleEnumStandingActive: {
		defaultValue: 'Standings Active',
		displayPath: `${dpRoot}${CfcRule.StandingActive}`,
		description: `System value for '${CfcRule.StandingActive}' Cfc Rule.`,
		legacyName: 'Announcements/System.Enum.CfcRule.StandingActive',
		feature: HubFeature.CredentialAchievements,
		...sharedLocData,
	},
	SPCfcRuleEnumStandingInactive: {
		defaultValue: 'Standings Inactive',
		displayPath: `${dpRoot}${CfcRule.StandingInactive}`,
		description: `System value for '${CfcRule.StandingInactive}' Cfc Rule.`,
		legacyName: 'Announcements/System.Enum.CfcRule.StandingInactive',
		feature: HubFeature.CredentialAchievements,
		...sharedLocData,
	},
	SPCfcRuleEnumClaListItems: {
		defaultValue: 'Client Sponsor Settings',
		displayPath: `${dpRoot}${CfcRule.ClaListItems}`,
		description: `System value for '${CfcRule.ClaListItems}' Cfc Rule.`,
		feature: HubFeature.Core,
		...sharedLocData,
	},
};

export const CERT_STATUS_ENUM_LOCS = MapLocKeys<SPCfcRuleLocs>({
	...spCfcRuleEnumLocs,
});

export type SPCfcRuleEnumLocType = LocMap<SPCfcRuleLocs>;

export const spCfcRuleKeys: { [key in CfcRule]: keyof SPCfcRuleEnumLocType } = {
	[CfcRule.CcatAchieved]: CERT_STATUS_ENUM_LOCS.SPCfcRuleEnumCcatAchieved,
	[CfcRule.CcatActive]: CERT_STATUS_ENUM_LOCS.SPCfcRuleEnumCcatActive,
	[CfcRule.CcatExpired]: CERT_STATUS_ENUM_LOCS.SPCfcRuleEnumCcatExpired,
	[CfcRule.CcatInactive]: CERT_STATUS_ENUM_LOCS.SPCfcRuleEnumCcatInactive,
	[CfcRule.CcatSuspended]: CERT_STATUS_ENUM_LOCS.SPCfcRuleEnumCcatSuspended,
	[CfcRule.CrcatAchieved]: CERT_STATUS_ENUM_LOCS.SPCfcRuleEnumCrcatAchieved,
	[CfcRule.CrcatActive]: CERT_STATUS_ENUM_LOCS.SPCfcRuleEnumCrcatActive,
	[CfcRule.CrcatInactive]: CERT_STATUS_ENUM_LOCS.SPCfcRuleEnumCrcatInactive,
	[CfcRule.ExcatFailed]: CERT_STATUS_ENUM_LOCS.SPCfcRuleEnumExcatFailed,
	[CfcRule.ExcatPassed]: CERT_STATUS_ENUM_LOCS.SPCfcRuleEnumExcatPassed,
	[CfcRule.ExcatTaken]: CERT_STATUS_ENUM_LOCS.SPCfcRuleEnumExcatTaken,
	[CfcRule.IcCodeAddr1]: CERT_STATUS_ENUM_LOCS.SPCfcRuleEnumIcCodeAddr1,
	[CfcRule.StandingAchieved]: CERT_STATUS_ENUM_LOCS.SPCfcRuleEnumStandingAchieved,
	[CfcRule.StandingActive]: CERT_STATUS_ENUM_LOCS.SPCfcRuleEnumStandingActive,
	[CfcRule.StandingInactive]: CERT_STATUS_ENUM_LOCS.SPCfcRuleEnumStandingInactive,
	[CfcRule.ClaListItems]: CERT_STATUS_ENUM_LOCS.SPCfcRuleEnumClaListItems,
};
